<template>
  <collapsible-card
    :heading="symptom.name"
    paddingless-content
  >
    <article>
      <div class="card has-background-light">
        <section
          v-for="key in symptomKeys"
          :key="key"
        >
          <h1 class="is-inline-block has-text-weight-semibold is-padded-small">
            {{ key | underscoresToSpaces | capitalizeFirstLetter }}
          </h1>
          <p class="is-inline-block is-padded-small">{{ symptom[key] }}</p>
        </section>
      </div>
      <h1 class="has-text-weight-semibold is-size-5 is-padded-small">Treatments</h1>
      <div
        class="card has-background-light"
        v-for="treatment in treatments"
        :key="treatment.name"
      >
        <section>
          <h1 class="has-text-weight-semibold is-size-6 is-padded-small">{{ treatment.name }}</h1>
        </section>
        <section
          v-for="key in treatmentKeys"
          :key="key"
        >
          <h1 class="is-inline-block has-text-weight-semibold is-padded-small">
            {{ key | underscoresToSpaces | capitalizeFirstLetter }}
          </h1>
          <p class="is-inline-block is-padded-small">{{ treatment[key] }}</p>
        </section>
      </div>
    </article>
  </collapsible-card>
</template>

<script>
import CollapsibleCard from '@/components/structures/CollapsibleCard'

export default {
  components: {
    CollapsibleCard,
  },
  props: {
    symptom: {
      type: Object,
      required: true
    },
    treatments: {
      type: Array,
      require: true
    }
  },
  computed: {
    symptomKeys () {
      return ['icd_code', 'icpc_code', 'incubation_time', 'infection_rate', 'guides']
    },
    treatmentKeys () {
      return ['description', 'antidote', 'antidote_dose', 'antidote_dose_ratio', 'antidote_dose_time_length', 'mouth_to_mouth', 'induce', 'contraindicated_drugs']
    }
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.treatment-container {
  border-bottom: 1px solid grey;
  margin-bottom: 10px;
}
</style>
